import type { MaintenanceScoreResult } from '../../types/analysis.types';
import { now } from './common';

/**
 * Maintenance score demo - 6-pillar system.
 */
export const vibeMapperMaintenanceScore: MaintenanceScoreResult = {
  overallScore: 64,
  grade: 'C',
  collectedAt: now,
  hardCapsApplied: [],
  pillarScores: [
    {
      name: 'activity',
      score: 100,
      weight: 0.167,
      weightedScore: 16.7,
      details: {
        commitCount30d: 796,
        commitCount90d: 2037,
        daysSinceLastCommit: 0,
        activeContributors30d: 9,
        commitTrend: 'increasing' as const,
      },
    },
    {
      name: 'cicd',
      score: 70,
      weight: 0.167,
      weightedScore: 11.69,
      details: {
        hasCI: true,
        ciPlatform: 'GitLab CI',
        workflowCount: 1,
        hasCD: false,
        hasTestAutomation: true,
      },
    },
    {
      name: 'issues_prs',
      score: 100,
      weight: 0.167,
      weightedScore: 16.7,
      details: {
        openPRCount: 7,
        mergedPRCount30d: 26,
        avgPRMergeTimeHours: null,
        openIssueCount: 8,
        closedIssueCount30d: 4,
        avgIssueCloseTimeHours: null,
        hasIssueTemplates: false,
        hasPRTemplates: false,
      },
    },
    {
      name: 'dependency',
      score: 60,
      weight: 0.167,
      weightedScore: 10.02,
      details: {
        driftRatio: 0.65,
        totalDependencies: 370,
        outdatedDependencies: 240,
        oldestPinnedYears: 2.1,
        hasDependabot: false,
        hasRenovate: false,
      },
    },
    {
      name: 'release',
      score: 0,
      weight: 0.167,
      weightedScore: 0,
      details: {
        releaseCount12m: 0,
        daysSinceLastRelease: null,
        hasSemanticVersioning: false,
        hasChangelog: true,
        releaseFrequencyDays: null,
      },
    },
    {
      name: 'metadata',
      score: 55,
      weight: 0.167,
      weightedScore: 9.19,
      details: {
        hasReadme: true,
        hasLicense: true,
        hasDescription: false,
        hasTopics: false,
        topicCount: 0,
        hasContributing: true,
        hasCodeOfConduct: false,
      },
    },
  ],
};
